// Totais do período, calculados a partir das linhas do relatório
const ReportSummary = ({ items, loading }) => (
  <div className="admin-report__summary">
    {items.map((item) => (
      <div key={item.label} className="admin-home-stat admin-report__stat">
        <span className="admin-home-stat__label">{item.label}</span>
        {loading ? (
          <span className="admin-home-skeleton admin-home-skeleton--value" />
        ) : (
          <span className="admin-home-stat__value">{item.value}</span>
        )}
        {item.hint && !loading && <span className="admin-muted">{item.hint}</span>}
      </div>
    ))}
  </div>
);

export default ReportSummary;
